import { useQuery } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';
import { workflowAtom } from '../../atoms';
import { exportWorkflowToXML } from './exportWorkflowService';

export const useExportWorkflow = () => {
  const workflow = useAtomValue(workflowAtom);

  const {
    data: xmlContent,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  } = useQuery({
    gcTime: 0,
    queryFn: () => exportWorkflowToXML(workflow),
    queryKey: ['exportWorkflow', workflow],
    retry: false,
  });

  return { error, isError, isFetching, isLoading, refetch, xmlContent };
};
